import React, { useState } from "react";
import toast from "react-hot-toast";
import SystemModal from "../Common/SystemModal";
import ajaxRole from "../../util/remote/ajaxRole"; // make sure this exists
const CreateRole = () => {
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);
  const handleAdd = async (e, controls) => {
    e.preventDefault();
    if (role.trim().length === 0) {
      toast.error("Complete all fields and try again");
      return;
    }
    setLoading(true);
    let data = {
      role_name: role.trim(),
    };
    const server_response = await ajaxRole.createRole(data);
    setLoading(false);
    if (server_response.status === "OK") {
      toast.success(server_response.message);
      setRole("");
      controls?.close(); // close modal after success
    } else {
      toast.error(server_response.message);
    }
  };
  const RenderFooter = (controls) => (
    <>
      <button
        className="btn ripple btn-dark"
        type="button"
        onClick={controls.close}
      >
        Close
      </button>
      <button
        className="btn ripple btn-primary"
        type="button"
        disabled={loading}
        onClick={(e) => handleAdd(e, controls)}
      >
        {loading ? "Saving..." : "Save"}
      </button>
    </>
  );
  return (
    <SystemModal
      title="Create Role"
      id="modal-create-role"
      size="md"
      footer={RenderFooter}
    >
      <div className="mb-3">
        <label className="form-label">Role Name</label>
        <input
          type="text"
          className="form-control"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          placeholder="Enter role name"
        />
      </div>
    </SystemModal>
  );
};
export default CreateRole;
